import { Injectable, inject } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { map, tap } from "rxjs/operators";
import { LorenBaseCrudService } from "../../../../shared/services/loren-base-crud-service/loren-base-crud.service";
import { LorenGroupEndpointsService } from "../loren-group-endpoints-service/loren-group-endpoints.service";
import { LorenHttpRequestOptions } from "../../../../shared/interfaces/loren-http-request-options.interface";
import { KeyValuePair } from "../../../../shared/interfaces/key-value-pair.interface";
import { GenericItems } from "../../../../shared/interfaces/generic-items.interface";
import { GroupItemModel } from "../../../../shared/modules/loren-hierarchy-selector/group.interface";

/**
 * @deprecated
 */
@Injectable({
  providedIn: "root",
})
export class LorenGroupService extends LorenBaseCrudService<GroupItemModel> {
  protected endpoints: LorenGroupEndpointsService;

  static newGroupCreated$ = new BehaviorSubject<GroupItemModel | null>(null);

  constructor() {
    const endpoints = inject(LorenGroupEndpointsService);

    super(endpoints.groups());

    this.endpoints = endpoints;
  }

  query(
    requestOptions?: LorenHttpRequestOptions,
    getParams?: KeyValuePair<string>[]
  ): Observable<GenericItems<GroupItemModel>> {
    return super.query(requestOptions, getParams).pipe(
      map((x) => ({
        items: x.items.sort((a, b) => {
          if (a?.name > b?.name) {
            return 1;
          }

          if (a?.name < b?.name) {
            return -1;
          }

          return 0;
        }),
      }))
    );
  }

  getHierarchySelectorData(): Observable<GroupItemModel> {
    return this.http
      .get<GroupItemModel>(this.endpoints.groupsHierarchy(), {})
      .pipe(tap((x) => (x.isRoot = true)));
  }
}
